export const jobRoleApi = {
    getJobRole: 'v1/api/jobrole',
    createJobRole: 'v1/api/jobrole',
    editJobRole: 'v1/api/jobrole',
    deleteJobRole: 'v1/api/jobrole',
    editJobRoleByID:'v1/api/jobrole/getRoleById?jobRoleId='
};
